export const sitesConstants = {
  GET_SITES: "GET_SITES",
  GET_SITE: "GET_SITE",
  SET_LOADING: "SET_LOADING",
};
